import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  className?: string;
}

export default function LanguageSwitcher({ className = '' }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'en' ? 'ar' : 'en');
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`px-4 py-2 bg-background-200 text-foreground-800 rounded-lg hover:bg-background-300 transition-all whitespace-nowrap cursor-pointer font-semibold text-sm ${className}`}
      aria-label="Switch language"
    >
      {i18n.language === 'en' ? 'ع' : 'EN'}
    </button>
  );
}